// TODO: route↔asset mappings duplicated in getRouteLinkFromAsset and chapter-dropdown-item assetRoute.
const ROUTE_ASSET_MAPPINGS = [
  { routeName: 'module_quiz', assetType: 'quiz', paramKey: 'moduleQuizId' },
  { routeName: 'module_video', assetType: 'video', paramKey: 'moduleVideoId' },
  { routeName: 'module_slides', assetType: 'slide_deck', paramKey: 'moduleSlidesId' },
  { routeName: 'module_lu', assetType: 'learning_unit', paramKey: 'moduleLuId' },
  { routeName: 'module_calendar_event', assetType: 'calendar_event', paramKey: 'moduleCalendarEventId' },
  { routeName: 'module_meeting', assetType: 'meeting', paramKey: 'moduleMeetingId' },
  { routeName: 'module_markdown_page', assetType: 'markdown_page', paramKey: 'moduleMarkdownPageId' },
  { routeName: 'module_questionnaire', assetType: 'questionnaire', paramKey: 'moduleQuestionnaireId' },
];

const SIDEBAR_SECTION_ROUTES = {
  module_landing: 'module_overview',
  module_knowledge_base: 'knowledge_base',
  knowledge_thread: 'knowledge_base',
  learner_keymaker_portal: 'learner_keymaker_portal',
};

export function getCurrentAssetFromRoute(route) {
  if (!route?.name) {
    return {};
  }

  const mapping = ROUTE_ASSET_MAPPINGS.find(({ routeName }) => route.name === routeName);
  if (mapping) {
    return {
      asset_type: mapping.assetType,
      id: route.params[mapping.paramKey],
    };
  }

  if (route.name.startsWith('pak_ov_')) {
    return {
      asset_type: 'pak',
      id: route.params.modulePakId,
    };
  }

  return {};
}

export function getCurrentSidebarSection(route) {
  if (!route?.name) {
    return null;
  }
  return SIDEBAR_SECTION_ROUTES[route.name] ?? null;
}

export function assetMatchesRoute(asset, route) {
  const current = getCurrentAssetFromRoute(route);
  if (!current.asset_type || current.id === undefined) {
    return false;
  }
  return current.asset_type === asset.asset_type && Number(current.id) === Number(asset.id);
}
